/**
 * RESPONSIBILITY: the @Choice column whose vocabulary lives in the document.
 *
 * Its own file because it is the one column that reads outside itself: `in` resolves
 * against the section root by default, so a row cell reaches the admin-owned list above
 * it, and `./name` stays inside the row.
 */
import { resolveOptions } from '@framework/core';
import { str, type Cell } from './cell-types';

const LookupCell: Cell['render'] = ({ field, value, onChange, id, root, row }) => {
  const allowed = field.in
    ? resolveOptions(field.in, root, row)
    : [...(field.fixed ?? [])];

  if (!field.multiple) {
    return (
      <select
        id={id} className="ctl-input" value={str(value)}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">—</option>
        {allowed.map((v) => <option key={v} value={v}>{v}</option>)}
      </select>
    );
  }

  const held: string[] = Array.isArray(value) ? (value as string[]) : [];
  return (
    // Toggle buttons, so there is no one control for the row's caption to point at.
    // The group carries the name instead.
    <div className="ctl-chips" role="group" aria-label={field.label}>
      {allowed.length === 0 && <span className="ctl-hint">{field.in} is empty</span>}
      {allowed.map((v) => (
        <button
          key={v} type="button" aria-pressed={held.includes(v)}
          className={held.includes(v) ? 'ctl-chip ctl-chip-on' : 'ctl-chip'}
          onClick={() => onChange(held.includes(v) ? held.filter((x) => x !== v) : [...held, v])}
        >{v}</button>
      ))}
    </div>
  );
};

export const lookupCell: Cell = {
  render: LookupCell,
  basis: (f) => (f.multiple ? '100%' : '18ch'),
};
